import {
  handleActions,
} from 'redux-actions';
import update from 'immutability-helper';
import PatientActionCreators from '../actions/PatientActionCreators';

const {
  fetchPatientListRequest,
  fetchPatientListSuccess,
  fetchPatientListFailure,
  fetchPatientDetailRequest,
  fetchPatientDetailSuccess,
  fetchPatientDetailFailure,
  updatePatientInfoRequest,
  updatePatientInfoSuccess,
  updatePatientInfoFailure,
  updatePatientDataRequest,
  updatePatientDataSuccess,
  updatePatientDataFailure,
} = PatientActionCreators;

const pageInfo = {
  number: 0,
  size: 25,
  totalElements: 25,
  totalPages: 1,
};

const initialState = {
  isPatientListLoading: false,
  isPatientDetailLoading: false,
  isPatientInfoUpdating: false,
  isPatientDataUpdating: false,
  patientList: [],
  patientDetail: {},
  pageInfo: {},
};

export default handleActions({
  // Requests
  [fetchPatientListRequest]: state => update(state, {
    isPatientListLoading: { $set: true },
  }),
  [fetchPatientDetailRequest]: state => update(state, {
    isPatientDetailLoading: { $set: true },
  }),
  [updatePatientInfoRequest]: state => update(state, {
    isPatientInfoUpdating: { $set: true },
  }),
  [updatePatientDataRequest]: state => update(state, {
    isPatientDataUpdating: { $set: true },
  }),
  // Success
  [fetchPatientListSuccess]: (state, { payload }) => update(state, {
    isPatientListLoading: { $set: false },
    patientList: { $set: payload },
    pageInfo: { $set: pageInfo },
  }),
  [fetchPatientDetailSuccess]: (state, { payload }) => update(state, {
    isPatientDetailLoading: { $set: false },
    patientDetail: { $set: payload },
  }),
  [updatePatientInfoSuccess]: (state, { payload }) => update(state, {
    isPatientInfoUpdating: { $set: false },
    patientDetail: { $set: payload },
  }),
  [updatePatientDataSuccess]: (state, { payload }) => update(state, {
    isPatientDataUpdating: { $set: false },
    patientDetail: { $set: payload },
  }),
  // Failures
  [fetchPatientListFailure]: (state, { payload }) => update(state, {
    isPatientListLoading: { $set: false },
    error: { $set: payload.error },
  }),
  [fetchPatientDetailFailure]: (state, { payload }) => update(state, {
    isPatientDetailLoading: { $set: false },
    error: { $set: payload.error },
  }),
  [updatePatientInfoFailure]: (state, { payload }) => update(state, {
    isPatientInfoUpdating: { $set: false },
    error: { $set: payload.error },
  }),
  [updatePatientDataFailure]: (state, { payload }) => update(state, {
    isPatientDataUpdating: { $set: false },
    error: { $set: payload.error },
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/patient.js